<template>
	<div name="hres7de-popup-tab3" id="hres7de-popup-tab3" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">

      <div class="modal-content">
        <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">{{ labels['HRES7DEP3']['10'] }}</h4>
        </div>
        <div class="modal-body detail detail-responsive">
          <div class="box-body">

             <div class="col-md-5">
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-5 control-label">{{ labels['HRES7DE6']['10'] }}</label>
                  <div class="col-md-7">
                    <div class="form-control readonly-field-color">{{ detailTab3Selected.desc_codinst }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-5 control-label">{{ labels['HRES7DE6']['20'] }}</label>
                  <div class="col-md-7">
                    <div class="form-control readonly-field-color">{{ indexSelected.codcours }} - {{ indexSelected.name }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-5 control-label">{{ labels['HRES7DE6']['30'] }}</label>
                  <div class="col-md-7">
                    <div class="form-control readonly-field-color">{{ detailTab3Selected.desc_codsubj }}</div>
                  </div>
                </div>
              </form>

              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-5 control-label">{{ labels['HRES7DE6']['80'] }}</label>
                  <div class="col-md-7">
                    <div class="form-control readonly-field-color">{{ detailTab3Selected.codform }} - {{ detailTab3Selected.desc_codform }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-5 control-label">{{ labels['HRES7DE6']['150'] }}</label>
                  <div class="col-md-7">
                    <textarea class="form-control"
                              v-model="detailTab3Selected.destrevl"
                              maxlength="100"
                              v-validate="'max:100'"
                              data-vv-name="destrevl"
                              :has-error="errors.has('destrevl')" ></textarea>
                    <div class="text-error" v-show="errors.has('destrevl')">{{errors.first('destrevl')}}</div>
                    <div class="remark-limit-character">{{ dispLimitLabel(100) }}</div>
                  </div>
                </div>
              </form>
              <div class="box-footer">
                <button type="button" class="btn bg-color-skin" @click="save()"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
              </div>
            </div>

            <div class="col-md-7" v-if="detailTab3Popup.table1.rows.length > 0">
              <div class="col-md-12 clear-padding">
                <div class="evaluation-wrapper">
                  <template v-for="dataGroup in detailTab3Popup.table1.rows">
                    <group  :labels="labels"
                            :dataGroup="dataGroup"
                            :choices="detailTab3Popup.table2.rows"
                            name="tab3"/>
                  </template>
                </div>
              </div>
              <div class="col-md-12 clear-padding">
                <div class="evaluation-sum">
                  {{ labels['HRES7DE6']['130'] }} {{ calResultScore(detailTab3Popup.table1.rows) }}/{{ calTotalScore(detailTab3Popup.table1.rows) }}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

		</div>
	</div>

</template>

<script >
import group from 'components/hres7de/group'
import { constLabels } from 'assets/js/constLabels.js'
import { numberFormat } from 'assets/js/numberFormat.js'

export default {
  name: 'hres7de-popup-tab3',
  data () {
    return {
      btn_close: 'Close'
    }
  },
  watch: {
    'detailTab3Selected.destrevl' () {
      this.$validator.validate('destrevl', this.detailTab3Selected.destrevl).catch(e => {})
    },
    detailTab3Selected () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    save () {
      let _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.postHres7deTab3PopupSave(_this.saveParams())
        }
      })
    },
    saveParams () {
      return {
        codempid: this.codeval,
        searchIndex: this.searchIndex,
        searchDetail: this.searchDetail,
        indexSelected: this.indexSelected,
        detailTab3: {
          selected: this.detailTab3Selected,
          popup: this.detailTab3Popup
        }
      }
    },
    calResultScore (dataGroups) {
      return dataGroups.map((dataGroup) => {
        return numberFormat(parseFloat(dataGroup.qtyscore))
      }).reduce((a, b) => {
        return numberFormat(parseFloat(a) + parseFloat(b))
      })
    },
    calTotalScore (dataGroups) {
      return dataGroups.map((dataGroup) => {
        return numberFormat(parseFloat(dataGroup.qtyfscor))
      }).reduce((a, b) => {
        return numberFormat(parseFloat(a) + parseFloat(b))
      })
    }
  },
  props: [
    'labels',
    'labelsButton',
    'nowLang',
    'detailTab3Selected',
    'detailTab3Popup',
    'searchIndex',
    'codeval',
    'indexSelected',
    'postHres7deTab3PopupSave',
    'searchDetail'
  ],
  components: {
    group
  }
}
</script>



// WEBPACK FOOTER //
// popupTab3.vue?90e334f2